import PropTypes from "prop-types";
import SettingsField from "./SettingsField";
import SettingsSection from "./SettingsSection";
import { fieldId } from "./settingsForm";
import { formatDay, formatNumber } from "../lib/format";

/**
 * Bodyweight, dated (D17): it turns chin-ups into an effective load. In
 * the settings' units — after a units switch the field shows the saved
 * weight converted (the server converts it the same way on save) unless a
 * new number is typed.
 */
function BodyweightSection({ value, onChange, units, settings, error }) {
  const saved = settings?.bodyweight;
  const hasSaved = saved !== null && saved !== undefined && saved !== "";
  const savedUnits = settings?.units ?? units;
  const setOn = settings?.bodyweight_at
    ? formatDay(settings.bodyweight_at, settings?.timezone)
    : "";
  let status;
  if (!hasSaved) status = "Not set yet.";
  else if (setOn) status = `${formatNumber(saved)} ${savedUnits}, set on ${setOn}.`;
  else status = `${formatNumber(saved)} ${savedUnits}.`;
  const converting = hasSaved && savedUnits !== units;

  return (
    <SettingsSection
      id="training-settings-bodyweight"
      title="Bodyweight"
      description={
        <p>
          Chin-ups are planned as an effective load: bodyweight + added weight − band assist.
          Without it, chin-ups progress by reps, then a lighter band, then added weight.
        </p>
      }
    >
      <p className="m-0 text-sm">{status}</p>
      <SettingsField
        id={fieldId("bodyweight")}
        label="Bodyweight"
        value={value}
        onChange={onChange}
        unit={units}
        placeholder={units === "kg" ? "e.g. 82.5" : "e.g. 182.5"}
        error={error || undefined}
        helper={
          converting
            ? `Converted from ${formatNumber(saved)} ${savedUnits}; saves as shown, or type a new weight in ${units}.`
            : `In ${units}. Leave it blank if you'd rather not say; a new number is dated today.`
        }
        className="max-w-xs"
      />
    </SettingsSection>
  );
}

BodyweightSection.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  units: PropTypes.string.isRequired,
  settings: PropTypes.object,
  error: PropTypes.string,
};

export default BodyweightSection;
